import { throttle } from "lodash";
import { useEffect, useState } from "react";

export function useCategoryInView(): [
  string | null | undefined,
  React.Dispatch<React.SetStateAction<string | null | undefined>>
] {
  const [categoryInView, setCategoryInView] = useState<string | null>();
  useEffect(() => {
    const calculateCategoryInView = (): string | null => {
      const inViewCategories: Element[] = [];
      const categories = document?.querySelectorAll(".category");
      const header = document?.querySelector("header");
      const headerHeight = header ? header?.getBoundingClientRect().height : 0;
      const maxVisiblePercentage = 25;

      for (const category of categories) {
        const rect = category?.getBoundingClientRect();
        const windowHeight =
          window?.innerHeight || document?.documentElement?.clientHeight;
        const visibleHeight =
          Math?.min(windowHeight, rect?.bottom) -
          Math?.max(headerHeight, rect?.top);
        const elementHeight = rect?.bottom - rect?.top;
        if (elementHeight > 0) {
          const visiblePercentage = (visibleHeight / elementHeight) * 100;
          const isInView =
            rect.top < windowHeight &&
            rect.bottom >= 0 &&
            rect.left <=
              (window?.innerWidth || document?.documentElement?.clientWidth) &&
            rect.right >= 0;

          if (isInView && visiblePercentage > maxVisiblePercentage) {
            inViewCategories.push(category);
          }
        }
      }
      return inViewCategories?.[0]?.id ?? null;
    };

    const handleScroll = throttle(() => {
      const currentCategory = calculateCategoryInView();
      setCategoryInView(() => currentCategory);
    }, 200);
    // container with scrollable content
    const mainElement = document?.querySelector("main");
    mainElement?.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      mainElement?.removeEventListener("scroll", handleScroll);
      handleScroll.cancel();
    };
  }, []);

  return [categoryInView, setCategoryInView];
}
